// Credit card benefit data for the Cards tab. Fees/credits verified Sep 2026.
// matchKeywords: lowercase strings matched against the user's subscription names.
// Empty matchKeywords = general credit (travel, hotel, airline) — not auto-detected.
// annualValue: null = percentage cashback, shown as info-only, not counted in math.

export const CREDIT_CARD_BENEFITS = [
  {
    name: "Amex Platinum",
    annualFee: 895,
    referralUrl: "https://americanexpress.com/en-us/referral/platinum-card?ref=MICHAHXAz6&XL=MNANS",
    welcomeBonus: null,
    benefits: [
      {
        name: "Uber Cash",
        annualValue: 200,
        description: "$15/mo + $35 in December toward Uber rides or Uber Eats",
        matchKeywords: ["uber"],
      },
      {
        name: "Uber One Credit",
        annualValue: 120,
        description: "$10/mo statement credit toward an Uber One membership",
        matchKeywords: ["uber one"],
      },
      {
        name: "Digital Entertainment Credit",
        annualValue: 300,
        description: "$25/mo toward Disney+, Hulu, Paramount+, Peacock, The New York Times, and more",
        matchKeywords: ["disney", "hulu", "paramount", "peacock", "new york times", "espn"],
      },
      {
        name: "Equinox Credit",
        annualValue: 300,
        description: "Up to $300/yr toward Equinox gym membership",
        matchKeywords: ["equinox"],
      },
      {
        name: "CLEAR Plus Credit",
        annualValue: 209,
        description: "Annual credit covering CLEAR Plus airport security membership",
        matchKeywords: ["clear plus", "clear"],
      },
      {
        name: "Hotel Credit (FHR / THC)",
        annualValue: 600,
        description: "Up to $600/yr on prepaid Fine Hotels + Resorts or The Hotel Collection bookings",
        matchKeywords: [],
      },
      {
        name: "Resy Dining Credit",
        annualValue: 400,
        description: "Up to $400/yr at Resy-listed restaurants ($100/quarter)",
        matchKeywords: [],
      },
      {
        name: "lululemon Credit",
        annualValue: 300,
        description: "Up to $300/yr in credits at lululemon ($75/quarter)",
        matchKeywords: [],
      },
      {
        name: "Airline Fee Credit",
        annualValue: 200,
        description: "$200/yr toward baggage fees, seat upgrades, and more on one selected airline",
        matchKeywords: [],
      },
    ],
  },
  {
    name: "Chase Sapphire Reserve",
    annualFee: 795,
    referralUrl: "https://www.referyourchasecard.com/19w/03BNDTHLIN",
    welcomeBonus: "150,000 bonus points",
    benefits: [
      {
        name: "Annual Travel Credit",
        annualValue: 300,
        description: "$300/yr travel credit applied automatically to travel purchases",
        matchKeywords: [],
      },
      {
        name: "Apple TV+ & Apple Music",
        annualValue: 250,
        description: "Complimentary Apple TV+ and Apple Music subscriptions while the card is active",
        matchKeywords: ["apple tv", "apple music"],
      },
      {
        name: "DashPass Membership",
        annualValue: 120,
        description: "Complimentary DoorDash DashPass membership while the card is active",
        matchKeywords: ["doordash", "dashpass"],
      },
      {
        name: "The Edit Hotel Credit",
        annualValue: 500,
        description: "Up to $500/yr in credits on prepaid hotel stays booked through The Edit",
        matchKeywords: [],
      },
      {
        name: "Exclusive Tables Dining Credit",
        annualValue: 300,
        description: "Up to $300/yr at Sapphire Reserve Exclusive Tables restaurants",
        matchKeywords: [],
      },
      {
        name: "StubHub Credit",
        annualValue: 300,
        description: "Up to $300/yr toward event tickets on StubHub",
        matchKeywords: [],
      },
    ],
  },
  {
    name: "Amex Gold",
    annualFee: 325,
    benefits: [
      {
        name: "Dining Credit",
        annualValue: 120,
        description: "$10/mo at Grubhub, Cheesecake Factory, Goldbelly, Five Guys, Shake Shack, and more",
        matchKeywords: ["grubhub", "grub hub"],
      },
      {
        name: "Uber Cash",
        annualValue: 120,
        description: "$10/mo toward Uber rides or Uber Eats",
        matchKeywords: ["uber"],
      },
      {
        name: "Dunkin' Credit",
        annualValue: 84,
        description: "$7/mo credit toward Dunkin' purchases",
        matchKeywords: ["dunkin"],
      },
      {
        name: "Resy Credit",
        annualValue: 100,
        description: "$50 credit twice a year on dining at Resy-listed restaurants",
        matchKeywords: [],
      },
    ],
  },
  {
    name: "Chase Sapphire Preferred",
    annualFee: 95,
    referralUrl: "https://www.referyourchasecard.com/19w/03BNDTHLIN",
    welcomeBonus: "75,000 bonus points",
    benefits: [
      {
        name: "Annual Hotel Credit",
        annualValue: 50,
        description: "$50/yr credit toward hotels booked through Chase Travel",
        matchKeywords: [],
      },
      {
        name: "DashPass Membership",
        annualValue: 120,
        description: "Complimentary DoorDash DashPass for the first 12 months",
        matchKeywords: ["doordash", "dashpass"],
      },
      {
        name: "Instacart+ Membership",
        annualValue: 30,
        description: "Complimentary Instacart+ for 3 months, then discounted",
        matchKeywords: ["instacart"],
      },
    ],
  },
  {
    name: "Capital One Venture X",
    annualFee: 395,
    benefits: [
      {
        name: "Capital One Travel Credit",
        annualValue: 300,
        description: "$300/yr credit toward travel booked through Capital One Travel",
        matchKeywords: [],
      },
      {
        name: "Anniversary Bonus Miles",
        annualValue: 100,
        description: "10,000 bonus miles each account anniversary (~$100 in travel value)",
        matchKeywords: [],
      },
    ],
  },
  {
    name: "Citi Strata Premier",
    annualFee: 95,
    benefits: [
      {
        name: "Annual Hotel Savings",
        annualValue: 100,
        description: "$100 off a single hotel stay of $500+ booked through thankyou.com each year",
        matchKeywords: [],
      },
    ],
  },
  {
    name: "Amex Blue Cash Preferred",
    annualFee: 95,
    benefits: [
      {
        name: "Disney Bundle Credit",
        annualValue: 84,
        description: "$7/mo credit toward a Disney Bundle subscription (Disney+, Hulu, ESPN+)",
        matchKeywords: ["disney", "hulu", "espn"],
      },
      {
        name: "U.S. Streaming Cashback",
        annualValue: null,
        description: "6% cashback on U.S. streaming services (Netflix, Spotify, Hulu, and more)",
        matchKeywords: ["netflix", "spotify", "hulu", "disney", "max", "peacock", "paramount", "youtube premium", "apple tv"],
      },
    ],
  },
  {
    name: "Hilton Honors Amex Surpass",
    annualFee: 150,
    benefits: [
      {
        name: "Quarterly Resort Credit",
        annualValue: 200,
        description: "$50/quarter credit toward eligible Hilton resort purchases",
        matchKeywords: [],
      },
      {
        name: "Free Weekend Night Award",
        annualValue: 200,
        description: "One free weekend night at most Hilton properties each card anniversary year",
        matchKeywords: [],
      },
    ],
  },
];

// Cards whose value is primarily non-subscription (travel/hotel credits).
// These get a softer treatment in the cancel-recommendation logic.
export const GENERAL_CREDIT_CARD_NAMES = [
  "Capital One Venture X",
  "Citi Strata Premier",
  "Hilton Honors Amex Surpass",
  "Chase Sapphire Reserve",
];
